<template>
  <v-container align="start" :fluid="false">

    <v-row v-if="cart">
      <v-col xl="6" offset-xl="3" lg="8" offset-lg="2" md="8" offset-md="2" sm="8" offset-sm="2">
        <transition name="fade-transition">
          <div v-show="ready">
            <v-row align="start" justify="start">
              <v-col cols="12">
                <h1>{{ $t('views.checkout.cart.cart') }}</h1>
              </v-col>

            </v-row>

          <transition name="fade-transition">

            <div v-if="cart">
              <v-row v-for="(item, key) in cart.items" id="cart-item" class="ma-0" :key="key" :style="(key/2) === 0 || key === 0 ? 'border-bottom: 1px solid lightgrey; border-top: 1px solid lightgrey;' : 'border-bottom: 1px solid lightgrey;'">
                <v-col cols="3" class="pl-0">
                  <transition name="fade-transition">
                    <v-img aspect-ratio="1" class="pt-2" v-if="item.product.base_image" :src="item.product.base_image.optimized.small" @error="item.product.base_image.optimized.small = item.product.base_image.small_image_url" max-width="80"></v-img>
                    <v-img aspect-ratio="1" class="pt-2" v-if="!item.product.base_image && item.product.parent_base_image" :src="item.product.parent_base_image.optimized.small" @error="item.product.parent_base_image.optimized.small = item.product.parent_base_image.small_image_url" max-width="80"></v-img>
                  </transition>
                </v-col>
                <v-col cols="9">
                  <v-row>
                    <v-col cols="8" class="pa-0">
                      <h4>{{item.name}}</h4>
                    </v-col>
                    <v-col cols="4" align="center" class="pa-0">
                      <v-btn text icon color="pink" @click="openRemoveProductFromCartDialog(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="12" class="pa-0">
                      <v-btn text icon @click="removeItemFromCart(item.id)">
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                      {{item.quantity}}
                      <v-btn text icon @click="removeItemFromCart(item.id)">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>

          </transition>

          <v-row>
            <v-col cols="12">
              <div style="border-bottom:1px solid lightgrey;">
                <v-row>
                  <v-col cols="12">
                    <span @click="couponFieldOpen === true ? couponFieldOpen = false : couponFieldOpen = true " style="color:lightblue; text-decoration:underline; cursor:pointer;">{{ $t('views.checkout.discount.discount_start_btn') }}</span>
                  </v-col>
                  <v-expand-transition>
                    <v-col cols="12" v-show="couponFieldOpen || cart.coupon_code !== null">
                      <v-row>
                        <v-col cols="8" >
                            <v-text-field
                              ref="coupon-code"
                              :placeholder="$t('views.checkout.discount.coupon_code_text_field_label')"
                              outlined
                              dense
                              v-model="couponCode"
                              :error-messages="couponErrors"
                              :messages="couponMessages"
                              :success="CouponIsValid"
                              @focus="couponErrors = []"
                              color="primary"
                              :dark="$vuetify.theme.isDark"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4" >
                            <v-btn
                             @click="applyCouponToCart()"
                             :loading="loadingCoupon"
                             :disabled="loadingCoupon || !couponCode"
                             color="primary"
                             :style="'color:' + $vuetify.theme.currentTheme.onPrimary + ';'"
                            >
                              {{ $t('views.checkout.discount.coupon_code_apply_btn_text') }}
                            </v-btn>
                         </v-col>
                      </v-row>
                      <v-row v-if="cart.coupon_code">
                        <v-col cols="12" >
                          {{ $t('views.checkout.discount.coupons') }}:
                          <br>
                            <v-chip
                              class="ma-2"
                              close
                              color="green"
                              outlined
                              @click:close="removeCoupon()"
                              v-if="!removingCoupon"
                            >
                              {{cart.coupon_code}}
                            </v-chip>
                            <v-btn v-if="removingCoupon" disabled :loading="true" rounded>{{cart.coupon_code}}</v-btn>
                          </v-col>
                      </v-row>
                    </v-col>
                  </v-expand-transition>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="cart && cart.discount !== '0.0000'">
            <v-col cols="8" color="success">
              {{ $t('views.checkout.cart.summary.discount') }}
            </v-col>
            <v-col cols="4" align="end">
              -{{cart.formated_discount}}
            </v-col>
          </v-row>

          <v-row v-if="cart.selected_shipping_rate">
            <v-col cols="8">
              {{ $t('views.checkout.cart.summary.shipping') }}
            </v-col>
            <v-col cols="4" align="end">
              {{cart.selected_shipping_rate.formated_price}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              {{ $t('views.checkout.cart.summary.VAT') }}
            </v-col>
            <v-col cols="4" align="end">
              {{cart.formated_tax_total}}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8">
              {{ $t('views.checkout.cart.summary.total') }}
            </v-col>
            <v-col cols="4" align="end">
              {{cart.formated_grand_total}}
            </v-col>
          </v-row>

          <br>
          <billing></billing>
          <br>
          <shipping v-if="cart.selected_shipping_rate"></shipping>
          <br>
          <payment></payment>


          </div>
        </transition>

      </v-col>
    </v-row>

    <v-row>
      <v-col xl="8" offset-xl="2" lg="8" offset-lg="2" md="8" offset-md="2" sm="8" offset-sm="2">
        <div v-if="!cart">
          <h1>{{ $t('views.checkout.cart.cart') }}</h1>
          <br>
          <p>{{ $t('views.checkout.cart.cartIsEmpty') }}</p>

          <v-btn
            class="mt-6"
            color="primary"
            outlined
            to="/"
          >{{ $t('views.checkout.cart.BrowseCatalogBtn') }}</v-btn>
        </div>
      </v-col>
    </v-row>


    <v-dialog
      v-model="removeProductFromCartDialog"
      persistent
      max-width="290"
      v-if="itemToRemove"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">
          {{ $t('views.checkout.cart.removeFromCartDialog.removeFromTheCart') }}
        </v-card-title>
        <v-card-text>{{ $t('views.checkout.cart.removeFromCartDialog.removeFromTheCartBody', { itemToRemoveName: itemToRemove.name }) }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="cancelRemoveItemFromCart()"
          >
            {{ $t('views.checkout.cart.removeFromCartDialog.cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="removeItemFromCart()"
          >
            {{ $t('views.checkout.cart.removeFromCartDialog.affirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
// @ is an alias to /src
import CartService from "../services/CartService.js"
import Billing from "@/views/checkout/billing/Billing"
import Shipping from "@/views/checkout/shipping/Shipping"
import Payment from "@/views/checkout/payment/Stripe"

export default {
  name: 'home',
  components: {
    Billing,
    Shipping,
    Payment
  },
  data: () => ({
    ready: false,
    product: null,
    sheet: false,
    removeProductFromCartDialog: false,
    itemToRemove: null,
    couponFieldOpen: false,
    couponCode: null,
    couponErrors: [],
    couponMessages: [],
    loadingCoupon: false,
    CouponIsValid: false,
    removingCoupon: false,
  }),
  async mounted() {
    await this.getCart();
    if (this.cart) {
      await this.addInitialShippingMethod();
    }
  },
  computed: {
    cart() {
      return this.$store.state.checkout.cart;
    },
    locale () {
      if (!this.$store.state.app.locale) {
        // Set default locale
        return {code: process.env.VUE_APP_I18N_LOCALE}
      }
      return this.$store.state.app.locale
    }
  },
  methods: {
    determineDefaultShippingMethod() {
      return process.env.VUE_APP_DEFAULT_SHIPPING_RATE;
    },
    async addInitialShippingMethod() {

      // What do we want to do?
      // Check if a shipping method has already been set
      if (!this.cart.selected_shipping_rate) {
        // Check if the free shipping was returned, select it if is was
        if (this.cart) {
          for (var i = 0; i < this.cart.shipping_rates.length; i++) {
            if (this.cart.shipping_rates[i].method === 'free_free') {
              return await CartService.saveShippingMethodToCart(this.cart.shipping_rates[i].method)
              .then(response => {
                this.savePaymentMethodToCart(response.methods);
             }).catch(error => {
               console.log(error);
             })
            }
          }
        }


        let shippingMethod = this.determineDefaultShippingMethod();
        CartService.saveShippingMethodToCart(shippingMethod)
          .then(response => {
            this.savePaymentMethodToCart(response.methods);
         }).catch(error => {
           console.log(error);
         })
      }
    },
    async savePaymentMethodToCart(paymentMethods) {

      // What do we want to do?
      // If only one method was returned, select that.
      if (paymentMethods.length === 1) {
          console.log('Only one payment method returned');
          return CartService.savePaymentMethodToCart(paymentMethods[0].method);
      } else {
          console.log('Multiple payment methods returned');
         // Multiple was returned, try to see if one of them matches the default, set from the .env file.
         for (var i = 0; i < paymentMethods.length; i++) {
           if (paymentMethods[i].method == process.env.VUE_APP_DEFAULT_PAYMENT_METHOD) {
             return CartService.savePaymentMethodToCart(paymentMethods[i].method);
           }
         }
         // No match for the default was found, select the first one
         return CartService.savePaymentMethodToCart(paymentMethods[0].method);
      }
    },
    async setAddress() {

      var payload =

          {
            'billing': {
              "address1" :  {
              "0" : ''
              },
              "use_for_shipping" : true,
              "first_name" : 'first_name',
              "last_name" : 'last_name',
              "email" : 'this.email',
              "city" : 'this.city',
              // "state"  :"DK",
              "postcode" : 'this.zipCode',
              "country" : "Denmark",
              "phone" : 'this.phone',
              // "address_id" : 2,
            },
            'shipping': {
              "address1" :  {
              "0" : ""
              }
            }
          };

      CartService.saveAddressToCart(payload)
        .then(response => {
          this.$store.commit('mutateCart',response.cart);
          this.addInitialShippingMethod();
       }).catch(error => {
         console.log(error);
       })
    },
    async getCart() {
      if (!this.$store.state.checkout.cart) {
        CartService.getCart()
          .then(cart => {
            this.ready = true;
         }).catch(error => {
           console.log(error);
         })
      }
      this.ready = true;
    },
    openRemoveProductFromCartDialog(item) {
      this.removeProductFromCartDialog = true;
      this.itemToRemove = item;
    },
    removeItemFromCart() {
      CartService.removeItemFromCart(this.itemToRemove.id)
      .then(cart => {

     }).catch(error => {
       console.log(error);
     })

     this.removeProductFromCartDialog = false;
     this.itemToRemove = null;
   },
   cancelRemoveItemFromCart() {
     this.itemToRemove = null;
     this.removeProductFromCartDialog = false;
   },
   applyCouponToCart() {
     this.loadingCoupon = true;
     CartService.applyCouponToCart(this.couponCode)
     .then(response => {
       this.loadingCoupon = false;
       if (response.valid == false) {
         this.couponErrors.push(response.message)
       }
       if (response.valid == true) {

         this.CouponIsValid = true;
         this.couponMessages.push(response.message)
       }
    }).catch(error => {
      this.loadingCoupon = false;
      console.log(error);
    })
  },
  removeCoupon() {
    this.removingCoupon = true;
    CartService.removeCoupon()
    .then(response => {
      this.removingCoupon = false;

   }).catch(error => {
     this.removingCoupon = false;
     console.log(error);
   })
  }
 }
};
</script>



<style scoped>
  h4 {
    font-size: 10pt;
  }
</style>
